import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Title from './dev/Title';
import Subtitle from './dev/Subtitle';

const UserPayHistory = ({ userPayHistory, nextPayDate, currentCard = '',isCancelSubscription, messages, ...props}) => {
    const renderUserPayHistoryItem = ({ date, card, amount, pdfLink, paid },isMobile) => {
        return (
            <MobileWrap isMobile={isMobile}>
                {isMobile && 
                    <Content>
                        <Date nav isMobile={isMobile}>{messages.user_pay_date}</Date>
                        <Card nav isMobile={isMobile}>{messages.user_pay_method}</Card>
                        <Amount nav isMobile={isMobile}>{messages.user_pay_amunt}</Amount>
                        <PayResult nav isMobile={isMobile}>{messages.user_pay_result}</PayResult>
                        <PdfLink nav isMobile={isMobile}></PdfLink>
                    </Content>}
                <Content>
                    <Date isMobile={isMobile}>{date}</Date>
                    <Card isMobile={isMobile}>{card === "Free" ? messages.payment_free : card}</Card>
                    <Amount isMobile={isMobile}>${amount}</Amount>
                    <PayResult isMobile={isMobile}>{paid ? messages.user_pay_success : messages.user_pay_fail}</PayResult>
                    <a href={pdfLink}><PdfLink isMobile={isMobile}>INVOICE</PdfLink></a>
                </Content>
            </MobileWrap>
        )
    }
    const renderRegular = () => {
        return (
            <React.Fragment>
                <Wrap regularTop>
                    <Content>
                        <Date nav>{messages.user_pay_date}</Date>
                        <Card nav>{messages.user_pay_method}</Card>
                        <Amount nav>{messages.user_pay_amunt}</Amount>
                        <PayResult nav>{messages.user_pay_result}</PayResult>
                        <PdfLink nav></PdfLink>
                    </Content>
                </Wrap>
                <Wrap regularBottom>
                    {userPayHistory !== [] && userPayHistory.map(i => renderUserPayHistoryItem(i,false))}
                </Wrap>
            </React.Fragment>
        )
    }
    const renderMobile = () => {
        return (
            <Wrap>
                {userPayHistory !== [] && userPayHistory.map(i => renderUserPayHistoryItem(i, true))}
            </Wrap>
        )
    }
    const { user: {isTrialing}} = props
    return (
        <Container>
            <Wrap>
                <TitleContent>
                    <Title>{messages.user_pay_history}</Title>
                    <div>
                        <Subtitle>{isCancelSubscription ? messages.user_pay_stop_pay : messages.user_pay_next_pay}：{nextPayDate}</Subtitle>
                        <Subtitle>{(isTrialing && !isCancelSubscription) ? messages.user_pay_free_trial_can_be_stop : messages.user_pay_contact}</Subtitle>
                        {/*  如試用期結束後不付費使用，請點選下方「停用方案」 : *若有付款相關問題，請聯絡我們 */}
                    </div>
                </TitleContent>
            </Wrap>
            <Wrap>
                <ExtendSubtitle nav>{messages.user_pay_card}</ExtendSubtitle>
                <Subtitle>
                    <div>{currentCard}</div>
                    {currentCard !== '' && <Edit onClick={() => props.dispatch({ type: 'togglePaymentField', isPaymentActive: true, paymentApiCase: 'changeCard', paymentTextCase: 'changeCard' })}>{messages.user_pay_change_card}</Edit>}
                </Subtitle>
            </Wrap>
            {window.innerWidth >= 900 && renderRegular()}
            {window.innerWidth < 900 && renderMobile()}
        </Container>
    )
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        messages: state.Messages,
    }
}
export default connect(mapStateToProps)(UserPayHistory);
const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 900px;
    margin-top: 30px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);  
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 20px 20px 0 20px;
    }         
    a {
        &:focus {
            text-decoration: none 
        }
    } 
`
const Wrap = styled.div`
    position: relative;
    width: 100%;
    padding: 48px;
    border-bottom: 1px solid #e6e6e6;
    ${({ regularTop }) => regularTop ? 'padding: 20px 48px 0 48px; border-bottom: 0;' : ''}
    ${({ regularBottom }) => regularBottom ? 'padding: 20px 48px 48px 48px;' : ''}
    &:last-child {
        border-bottom: 0;
    }
    @media (max-width: 900px){
        padding: 24px;
    } 
`
const MobileWrap = styled.div`
    display: ${props => props.isMobile ? 'flex' : ''};
`
const Content = styled.div`
    display: flex;
    justify-content: space-between;
    @media (max-width: 900px){
        flex-direction: column;
        justify-content: flex-start;
        width: 50%;
        padding: 10px 0;
        border-bottom: .5px solid #e6e6e6;
    }
`
const TitleContent = Content.extend`
    ${Title} {
        width: 50%;
    }
    @media (max-width: 900px){
        width: 100%;
    }
`
const ExtendSubtitle = Subtitle.extend`
    display: flex;
    justify-content: flex-start;
    font-size: ${props => props.nav ? '20px' : ''};
    font-weight: ${props => props.nav ? '500' : ''};
    @media (max-width: 900px){
        width: 100%;
        font-size: 16px;
    }
`
const Edit = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    margin-left: 15px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
`
const Date = ExtendSubtitle.extend`
    width: 90px;
    justify-content: ${props => props.isMobile ? 'flex-start' : 'center'};
`
const Card = ExtendSubtitle.extend`
    width: 200px;
    justify-content: ${props => props.isMobile ? 'flex-start' : 'center'};
`
const Amount = ExtendSubtitle.extend`
    width: 140px;
    justify-content: ${props => props.isMobile ? 'flex-start' : 'center'};
`
const PayResult = ExtendSubtitle.extend`
    width: 180px;
    justify-content: ${props => props.isMobile ? 'flex-start' : 'center'};
`
const PdfLink = ExtendSubtitle.extend`
    width: 65px;    
    color: #de0606;
    justify-content: ${props => props.isMobile ? 'flex-start' : 'center'};
`


// WEBPACK FOOTER //
// ./src/UserInfo/UserPayHistory.js